var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomViewYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_7999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#CE8500"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_7999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 2V11.5577H9.46964V13.5556C9.40795 13.5323 9.36505 13.5192 9.32434 13.5003C7.95597 12.8679 6.58915 12.2319 5.21827 11.6056C5.0567 11.5322 4.99877 11.4447 5.00002 11.2627C5.00879 9.90653 5.00628 8.55004 5.0066 7.19387C5.0066 5.52898 5.00597 3.86378 5.00566 2.19889C5.00566 2.13632 5.00566 2.07375 5.00566 2.00032H11.3281V2ZM10.8775 11.0817C10.8775 11.0016 10.8775 10.9387 10.8775 10.8758C10.8775 8.11522 10.8765 5.35467 10.8809 2.59412C10.8809 2.45972 10.8343 2.43578 10.7178 2.43641C9.24105 2.44535 7.76433 2.45046 6.28761 2.45717C6.23907 2.45717 6.19054 2.46291 6.142 2.4661C6.18302 2.51399 6.22718 2.53825 6.27289 2.55869C7.29182 3.01011 8.31012 3.46248 9.33061 3.91007C9.42987 3.95349 9.4687 4.00553 9.46838 4.12046C9.46463 6.38106 9.46525 8.64135 9.46525 10.902C9.46525 10.9588 9.46525 11.0156 9.46525 11.0817H10.8775ZM7.96661 9.40563H8.6699V9.16077H8.22494V7.25389H8.71468C8.67585 7.15237 8.65331 7.01892 8.61918 7.01573C8.40406 6.99625 8.18643 7.00583 7.9663 7.00583V9.40531L7.96661 9.40563Z",
    fill: "url(#paint0_linear_992_7999)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_992_7999",
    x1: 8.16403,
    y1: 2,
    x2: 8.16403,
    y2: 13.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomViewYellow);
export default __webpack_public_path__ + "static/media/room_view_yellow.edc641661e2754435ccf22c5c738504b.svg";
export { ForwardRef as ReactComponent };